/**
 * @generated SignedSource<<9aad472cceb4503305019e7e76462003>>
 * @relayHash 3480fd1da6619c5dab8c7f68351e6252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9ec32ddc7f209e30163f467d9ccd0cabdeedc4b5c5bc010aa0890cd3c651839

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggGoalTabContentQuery$variables = {
  containerId: string;
  goalKey: string;
  isDecisionsTab: boolean;
  isJiraAlignTab: boolean;
  isJiraTab: boolean;
  isLearningsTab: boolean;
  isProjectsTab: boolean;
  isRisksTab: boolean;
  isUpdatesTab: boolean;
  queryContext?: string | null;
};
export type AggGoalTabContentQuery$data = {
  readonly goals_byKey: {
    readonly " $fragmentSpreads": FragmentRefs<"AggGoalUpdatesTabContent" | "GoalContentAbout" | "GoalContentDecisions" | "GoalContentJira" | "GoalContentJiraAlign" | "GoalContentLearnings" | "GoalContentProjects" | "GoalContentRisks">;
  } | null;
};
export type AggGoalTabContentQuery = {
  response: AggGoalTabContentQuery$data;
  variables: AggGoalTabContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDecisionsTab"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraAlignTab"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraTab"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLearningsTab"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectsTab"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRisksTab"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUpdatesTab"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v10 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "goalKey",
    "variableName": "goalKey"
  }
],
v11 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "description"
},
v15 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v16 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v17 = {
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canCreateGoal"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "kind"
},
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v23 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v21/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v22/*: any*/)
  ]
},
v24 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v21/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v22/*: any*/)
  ]
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v26 = {
  "kind": "ScalarField",
  "name": "archived"
},
v27 = {
  "kind": "ScalarField",
  "name": "key"
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = {
  "kind": "ScalarField",
  "name": "url"
},
v30 = {
  "kind": "ScalarField",
  "name": "score"
},
v31 = [
  (v20/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = {
  "kind": "ScalarField",
  "name": "picture"
},
v34 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v35 = {
  "kind": "ScalarField",
  "name": "type"
},
v36 = {
  "kind": "ScalarField",
  "name": "subType"
},
v37 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v38 = [
  (v37/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v39 = {
  "kind": "ScalarField",
  "name": "time"
},
v40 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v41 = [
  (v13/*: any*/)
],
v42 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v31/*: any*/)
},
v43 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v45 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v46 = {
  "args": (v38/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v20/*: any*/),
            (v39/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v28/*: any*/),
                (v33/*: any*/),
                (v13/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v40/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v41/*: any*/)
                        },
                        (v42/*: any*/),
                        (v13/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v43/*: any*/),
            (v19/*: any*/)
          ]
        },
        (v44/*: any*/)
      ]
    },
    (v45/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v47 = {
  "args": (v38/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v48 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v49 = [
  (v20/*: any*/),
  (v13/*: any*/)
],
v50 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v49/*: any*/)
},
v51 = [
  (v39/*: any*/),
  (v13/*: any*/)
],
v52 = {
  "kind": "ScalarField",
  "name": "end"
},
v53 = {
  "kind": "ScalarField",
  "name": "variance"
},
v54 = {
  "args": (v38/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v51/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareTargetDateRange",
                  "kind": "LinkedField",
                  "name": "dateRange",
                  "plural": false,
                  "selections": [
                    (v52/*: any*/)
                  ]
                }
              ]
            },
            (v20/*: any*/)
          ]
        },
        (v53/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v55 = {
  "kind": "ScalarField",
  "name": "start"
},
v56 = [
  {
    "concreteType": "TownsquareTargetDateRange",
    "kind": "LinkedField",
    "name": "dateRange",
    "plural": false,
    "selections": [
      (v52/*: any*/),
      (v55/*: any*/)
    ]
  }
],
v57 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v49/*: any*/)
    },
    (v53/*: any*/)
  ]
},
v58 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v56/*: any*/)
},
v59 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v60 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v61 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v62 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v63 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v28/*: any*/),
                (v13/*: any*/),
                (v61/*: any*/),
                (v33/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v62/*: any*/),
            (v40/*: any*/)
          ]
        }
      ]
    },
    (v43/*: any*/)
  ]
},
v64 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v65 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v66 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v67 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v55/*: any*/),
    (v52/*: any*/)
  ]
},
v68 = [
  (v67/*: any*/)
],
v69 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ]
},
v70 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v71 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v70/*: any*/)
  ]
},
v72 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v70/*: any*/),
    (v35/*: any*/)
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "source"
},
v74 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v51/*: any*/)
},
v75 = {
  "kind": "ScalarField",
  "name": "label"
},
v76 = {
  "kind": "ScalarField",
  "name": "summary"
},
v77 = [
  (v19/*: any*/),
  (v61/*: any*/),
  (v28/*: any*/),
  (v33/*: any*/),
  (v13/*: any*/)
],
v78 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v77/*: any*/)
},
v79 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v80 = [
  (v19/*: any*/),
  (v33/*: any*/),
  (v28/*: any*/),
  (v61/*: any*/),
  (v13/*: any*/)
],
v81 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v80/*: any*/)
},
v82 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v80/*: any*/)
},
v83 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v84 = [
  (v40/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v30/*: any*/),
      (v75/*: any*/)
    ]
  },
  (v76/*: any*/),
  (v78/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v76/*: any*/),
              (v14/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v13/*: any*/),
              (v76/*: any*/),
              (v14/*: any*/),
              (v79/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v40/*: any*/),
              (v83/*: any*/)
            ]
          }
        ]
      },
      (v43/*: any*/)
    ]
  },
  (v13/*: any*/)
],
v85 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v84/*: any*/)
},
v86 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v87 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v28/*: any*/),
                (v35/*: any*/),
                (v36/*: any*/),
                (v26/*: any*/),
                (v65/*: any*/),
                (v73/*: any*/),
                (v74/*: any*/)
              ]
            },
            (v50/*: any*/),
            (v66/*: any*/),
            (v48/*: any*/)
          ]
        }
      ]
    }
  ]
},
v88 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v68/*: any*/)
},
v89 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v77/*: any*/)
},
v90 = {
  "concreteType": "TownsquareUserConnection",
  "kind": "LinkedField",
  "name": "watchers",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v91 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v92 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v93 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v94 = [
  (v20/*: any*/),
  (v39/*: any*/),
  (v13/*: any*/)
],
v95 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v27/*: any*/)
  ]
},
v96 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v97 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v92/*: any*/),
          (v93/*: any*/),
          (v76/*: any*/),
          (v62/*: any*/),
          (v40/*: any*/),
          (v13/*: any*/)
        ]
      }
    ]
  }
],
v98 = [
  (v75/*: any*/),
  (v67/*: any*/)
],
v99 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v100 = {
  "kind": "ScalarField",
  "name": "canDeleteUpdates"
},
v101 = {
  "kind": "InlineFragment",
  "selections": (v41/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v102 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v103 = [
  (v102/*: any*/),
  (v11/*: any*/)
],
v104 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v76/*: any*/),
      (v14/*: any*/),
      (v81/*: any*/),
      (v82/*: any*/),
      (v40/*: any*/),
      (v83/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v105 = {
  "concreteType": "TownsquareGoalCapabilities",
  "kind": "LinkedField",
  "name": "capabilities",
  "plural": false,
  "selections": [
    (v100/*: any*/),
    (v99/*: any*/)
  ]
},
v106 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v107 = [
  (v102/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v108 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v21/*: any*/)
},
v109 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v13/*: any*/),
    (v28/*: any*/),
    (v33/*: any*/),
    (v61/*: any*/)
  ]
},
v110 = [
  (v19/*: any*/),
  (v13/*: any*/)
],
v111 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v110/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v110/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v112 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v113 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v68/*: any*/)
},
v114 = {
  "args": (v107/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalContentAbout"
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "AggGoalUpdatesTabContent"
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJiraAlign"
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJira"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentLearnings"
              }
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentRisks"
              }
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentDecisions"
              }
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentProjects"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v17/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v13/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ]
              },
              (v13/*: any*/),
              (v23/*: any*/)
            ]
          },
          {
            "args": (v25/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v13/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v32/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v33/*: any*/),
                          (v28/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v34/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v35/*: any*/),
                                      (v36/*: any*/),
                                      (v28/*: any*/),
                                      (v13/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/)
                                    ]
                                  },
                                  (v48/*: any*/),
                                  (v50/*: any*/),
                                  (v13/*: any*/),
                                  (v54/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareTargetDate",
                                                "kind": "LinkedField",
                                                "name": "date",
                                                "plural": false,
                                                "selections": (v56/*: any*/)
                                              },
                                              (v20/*: any*/),
                                              (v57/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v58/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      (v59/*: any*/),
                      (v60/*: any*/)
                    ]
                  },
                  (v19/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v63/*: any*/),
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v64/*: any*/),
              (v13/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v28/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v26/*: any*/),
                          (v65/*: any*/),
                          (v43/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/)
                        ]
                      },
                      (v50/*: any*/),
                      (v66/*: any*/),
                      (v48/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "date",
                                    "plural": false,
                                    "selections": (v68/*: any*/)
                                  },
                                  (v20/*: any*/),
                                  (v57/*: any*/),
                                  (v19/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v54/*: any*/)
                    ]
                  }
                ]
              },
              (v43/*: any*/)
            ]
          },
          (v59/*: any*/),
          (v60/*: any*/),
          (v58/*: any*/),
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v21/*: any*/)
          },
          (v26/*: any*/),
          (v69/*: any*/),
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v30/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              (v34/*: any*/),
              (v71/*: any*/),
              {
                "args": (v25/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "successMeasures",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v72/*: any*/),
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v26/*: any*/),
                                          (v65/*: any*/),
                                          (v73/*: any*/),
                                          (v74/*: any*/)
                                        ]
                                      },
                                      (v66/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/)
                            ]
                          },
                          (v85/*: any*/),
                          (v64/*: any*/),
                          (v86/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "successMeasures(first:50)"
              },
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v28/*: any*/),
                          (v26/*: any*/),
                          (v72/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v87/*: any*/),
                          (v29/*: any*/),
                          (v34/*: any*/),
                          (v88/*: any*/),
                          (v89/*: any*/),
                          (v85/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "confidence"
                  }
                ]
              },
              (v90/*: any*/),
              {
                "args": (v91/*: any*/),
                "concreteType": "TownsquareGoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v76/*: any*/),
                          {
                            "concreteType": "TownsquareUpdateNoteConnection",
                            "kind": "LinkedField",
                            "name": "updateNotes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNoteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareUpdateNote",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v76/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v19/*: any*/),
                          (v64/*: any*/),
                          (v40/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v42/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareHighlightEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v76/*: any*/),
                                      (v14/*: any*/),
                                      (v19/*: any*/),
                                      (v13/*: any*/),
                                      (v79/*: any*/),
                                      (v81/*: any*/),
                                      (v82/*: any*/),
                                      (v40/*: any*/),
                                      (v83/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v43/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v28/*: any*/),
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v26/*: any*/),
                                          (v73/*: any*/),
                                          (v74/*: any*/),
                                          {
                                            "args": [
                                              (v37/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v94/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v94/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          (v13/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v26/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v55/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v20/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v13/*: any*/),
                              (v34/*: any*/),
                              (v26/*: any*/),
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              (v69/*: any*/),
                              {
                                "args": (v25/*: any*/),
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v28/*: any*/),
                                          (v26/*: any*/),
                                          (v72/*: any*/),
                                          (v87/*: any*/),
                                          (v29/*: any*/),
                                          (v34/*: any*/),
                                          (v88/*: any*/),
                                          (v89/*: any*/),
                                          (v85/*: any*/),
                                          (v64/*: any*/),
                                          (v86/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v95/*: any*/),
                                              (v13/*: any*/)
                                            ]
                                          },
                                          (v32/*: any*/),
                                          {
                                            "args": (v96/*: any*/),
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v97/*: any*/),
                                            "storageKey": "updates(first:10)"
                                          }
                                        ]
                                      },
                                      (v19/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "successMeasures(first:50)"
                              },
                              {
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v28/*: any*/),
                                          (v26/*: any*/),
                                          (v72/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v13/*: any*/),
                                              (v95/*: any*/)
                                            ]
                                          },
                                          (v87/*: any*/),
                                          (v29/*: any*/),
                                          (v34/*: any*/),
                                          (v88/*: any*/),
                                          (v89/*: any*/),
                                          (v85/*: any*/),
                                          (v86/*: any*/),
                                          (v32/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 30
                                              }
                                            ],
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v97/*: any*/),
                                            "storageKey": "updates(first:30)"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": (v96/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v76/*: any*/),
                                          {
                                            "concreteType": "TownsquareUpdateNoteConnection",
                                            "kind": "LinkedField",
                                            "name": "updateNotes",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNoteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v76/*: any*/),
                                                      (v14/*: any*/),
                                                      (v13/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              }
                            ]
                          },
                          (v78/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v98/*: any*/)
                          },
                          {
                            "args": (v25/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v71/*: any*/),
                                      (v13/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v84/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "nodeMissingReason"
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v70/*: any*/)
                                        ]
                                      },
                                      (v87/*: any*/),
                                      (v29/*: any*/),
                                      (v34/*: any*/),
                                      (v88/*: any*/),
                                      (v89/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v61/*: any*/),
                              (v28/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v62/*: any*/),
                          (v29/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/),
                                          (v28/*: any*/),
                                          (v61/*: any*/),
                                          (v33/*: any*/)
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "AppUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "CustomerUser"
                                      }
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          (v63/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v98/*: any*/)
                          }
                        ]
                      },
                      (v44/*: any*/),
                      (v19/*: any*/)
                    ]
                  },
                  (v45/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": "updates(first:20)"
              },
              {
                "args": (v91/*: any*/),
                "handle": "connection",
                "key": "UpdatesList__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              },
              {
                "concreteType": "TownsquareMetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/),
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "latestValue",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v20/*: any*/),
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "newValue",
                                "plural": false,
                                "selections": (v51/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canWatchGoal"
                  },
                  (v99/*: any*/),
                  (v100/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "isWatching"
              },
              (v27/*: any*/),
              (v86/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditUpdate"
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "updateStreak_extension"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v12/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                "kind": "LinkedField",
                "name": "jiraAlignItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectUrl"
                              }
                            ],
                            "type": "JiraAlignAggProject"
                          },
                          (v101/*: any*/)
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddJiraAlignItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveJiraAlignItems"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddLinkedWorkItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedWorkItems"
                  }
                ]
              },
              {
                "args": (v103/*: any*/),
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                "kind": "LinkedField",
                "name": "workItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v27/*: any*/),
                              (v76/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v101/*: any*/)
                        ]
                      },
                      (v44/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v45/*: any*/),
                  (v43/*: any*/)
                ]
              },
              {
                "args": (v103/*: any*/),
                "filters": [
                  "queryContext"
                ],
                "handle": "connection",
                "key": "GoalContentJira_workItems",
                "kind": "LinkedHandle",
                "name": "workItems"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v27/*: any*/),
              (v29/*: any*/),
              (v90/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "TownsquareLearning"
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v105/*: any*/)
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v27/*: any*/),
              (v29/*: any*/),
              (v90/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "TownsquareRisk"
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v105/*: any*/)
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v27/*: any*/),
              (v29/*: any*/),
              (v90/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "TownsquareDecision"
                          }
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/)
                ]
              },
              (v105/*: any*/)
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedProjects"
                  },
                  (v17/*: any*/),
                  (v106/*: any*/)
                ]
              },
              {
                "args": (v107/*: any*/),
                "concreteType": "TownsquareProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v44/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v13/*: any*/),
                          (v108/*: any*/),
                          (v109/*: any*/),
                          (v111/*: any*/),
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectPhaseDetails",
                                "kind": "LinkedField",
                                "name": "newPhase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "_id",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          },
                          (v86/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v112/*: any*/),
                          (v113/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v45/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": "projects(first:200,tql:\"archived = false\")"
              },
              (v114/*: any*/),
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v86/*: any*/),
                          (v28/*: any*/),
                          (v32/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v95/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          {
                            "args": (v107/*: any*/),
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v86/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v112/*: any*/),
                                      (v108/*: any*/),
                                      (v113/*: any*/),
                                      (v109/*: any*/),
                                      (v19/*: any*/),
                                      (v111/*: any*/)
                                    ]
                                  },
                                  (v44/*: any*/),
                                  (v19/*: any*/)
                                ]
                              },
                              (v45/*: any*/),
                              (v43/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          },
                          (v114/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v106/*: any*/)
                            ]
                          },
                          (v71/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v33/*: any*/),
                              (v61/*: any*/),
                              (v28/*: any*/),
                              (v13/*: any*/)
                            ]
                          },
                          (v88/*: any*/),
                          (v34/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v43/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f9ec32ddc7f209e30163f467d9ccd0cabdeedc4b5c5bc010aa0890cd3c651839",
    "metadata": {},
    "name": "AggGoalTabContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e5b238307163b80676f6c59fb94bc80";

export default node;
